import type { Values } from '@web-platform/shared-universal-types-utils/src/utils';

export const PAYMENT_DISCOUNT_POSITION = {
  BESIDES: 'besides',
  BELOW: 'below',
} as const;

export type PaymentDiscountPosition = Values<typeof PAYMENT_DISCOUNT_POSITION>;
